import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessAnomalyAlerts } from '@api/data-security';

export const getCoreDataSecurityAccessAnomalyAlertsSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessAnomalyAlerts',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessAnomalyAlerts,
	retainDataOnRequest: true
});
